module.exports = __webpack_public_path__ + "img/no_order.7df92086.png";